import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

// Helpers
import { getLocalesForDataCenter } from 'i18n/helpers';

// Types
import { DataCenter, Locale } from 'i18n/types';

// Styles
import styles from './LocalePicker.module.scss';

export interface RegionProps {
  dataCenter: DataCenter;
  closeModal: () => void;
}

export const Region: React.FC<RegionProps> = memo(({ closeModal, dataCenter: dc }) => {
  const { i18n } = useTranslation();
  const localesInDC = getLocalesForDataCenter(dc);

  const handleClick = (locale: Locale) => {
    i18n.changeLanguage(locale.code);
    closeModal();
  };

  if (!localesInDC.length) return null; // Don't render this data center block if there are no locales

  return (
    <div className={styles.region} key={dc.code}>
      <h3 className={styles.regionTitle}>{dc.displayName}</h3>
      <ul>
        {localesInDC.map(l => (
          <li key={l.code}>
            <button className={styles.localePickerButton} onClick={() => handleClick(l)} title={l.displayName} aria-label={l.displayName}>
              <img aria-hidden src={l.country.icon} alt={l.country.code} />
              <span lang={l.code}>{l.displayName}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
});
